/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContractDetailsDtoApiResponse } from '../../models/contract-details-dto-api-response';

export interface GetUserContractAsync$Plain$Params {
  id: number;
  contractId: number;
}

export function getUserContractAsync$Plain(http: HttpClient, rootUrl: string, params: GetUserContractAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ContractDetailsDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, getUserContractAsync$Plain.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('contractId', params.contractId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContractDetailsDtoApiResponse>;
    })
  );
}

getUserContractAsync$Plain.PATH = '/api/user/{id}/contract/{contractId}';
